import React from 'react'
import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';
import AppRouter from './routers/appRouter';
import {store, persistor} from './store/store';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <AppRouter/>
        </PersistGate>
    </Provider>
);

reportWebVitals();